import React, { PureComponent } from 'react';
import styled, { withTheme } from 'styled-components';
import Sizes from '../Assets/Sizes';
import { TransitionGroup } from "react-transition-group";
import { performIfDelegate, valueOrDefault } from "@tomeravni/easybizy-js-common/common";
import { injectIntl } from "react-intl";

const Carousel = styled.div`
  display: flex;
  padding: 0 ${ Sizes.defaultPadding };
  gap: ${ Sizes.defaultPadding };
  overflow: auto;
`;

const CarouselItem = styled.button`
  background-color: transparent;
  color: ${ props => !props.invertedColors ? props.theme.colors.primaryText : props.theme.colors.primaryTextInverted };
  font-size: 16px;
  border: 2px solid transparent;
  border-radius: ${ Sizes.listItemBorderRadius };
  padding: ${ Sizes.smallMargin } ${ Sizes.defaultPadding };
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  &.selected {
    border: 2px solid ${ props => !props.invertedColors ? props.theme.colors.primaryText : props.theme.colors.primaryTextInverted };
  }
`;

class HorizontalCarousel extends PureComponent {
	state = { items: [] };

	componentDidMount() {
	}


	componentWillReceiveProps(nextProps, nextContext) {

	}

	onSelected = (ev, item) => {
		performIfDelegate(this.props.onSelected, item);
	}

	render() {
		const { items } = this.props;
		const selectableItems = [{
			name: this.props.intl.formatMessage({ id: 'all_services' }),
			value: null
		}].concat(valueOrDefault(items, [])).map((item, idx) => {
			return (<CarouselItem key={ idx } className={ this.props.selected === item.value ? 'selected' : '' }
								  onClick={ (ev) => this.onSelected(ev, item) }>
				<div>{ item.name }</div>
			</CarouselItem>)
		});

		return <Carousel>
			<TransitionGroup component={ null }>
				{ selectableItems }
			</TransitionGroup>
		</Carousel>
	}
}

export default injectIntl(withTheme(HorizontalCarousel));
